<div class="cg-shell" (click)="onLayoutClick()">
    <aside class="cg-sidebar-desktop" [class.cg-sidebar-desktop-collapsed]="staticMenuDesktopInactive"><app-menu></app-menu></aside>
    <div class="cg-mobile-backdrop" *ngIf="staticMenuMobileActive"></div>
    <aside class="cg-sidebar-mobile" [class.cg-sidebar-mobile-open]="staticMenuMobileActive" (click)="$event.stopPropagation()">
        <app-menu></app-menu>
    </aside>
    <section class="cg-workspace">
        <app-topbar></app-topbar>
        <div class="cg-content-scroll">
            <main class="cg-main-content"><router-outlet></router-outlet></main>
            <app-footer></app-footer>
        </div>
    </section>
    <p-toast position="bottom-center" key="bc"></p-toast>
    <p-confirmDialog key="confirm1" [style]="{width: '425px'}" acceptButtonStyleClass="p-button-text"
    rejectButtonStyleClass="p-button-text"></p-confirmDialog>
</div>
